<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import AddEdit from "./addedit.vue";
import ofirma from "@/models/ofirma";
export default {
  mixins: [apibtoast, apigeneric, ofirma],
  page: {
    title: "Firmalar",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    AddEdit,
  },
  data() {
    return {
      title: this.$t("ofirma.Title"),
      items: [
        {
          text: this.$t("ofirma.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("ofirma.Page.UstMenu"),
          active: true,
        },
        {
          text: this.$t("ofirma.Title"),
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      FilterFirmaadi: "",
    };
  },
  methods: {
    Get() {
      this.ActionsFilterGet({
        Service: "OFirma",
        Page: this.Page,
        Filter: "&Firmaadi=" + this.FilterFirmaadi,
      }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
      });
    },
  },
};
</script>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
                <div class="col-sm-4">
                  <div class="search-box me-2 mb-2 d-inline-block">
                    <div class="position-relative">
                      <input type="text" @input="FilterFirmaadi.length >= 3 || FilterFirmaadi.length == 0 ? Get() : ''" v-model="FilterFirmaadi" class="form-control" :placeholder="$t('ofirma.Page.Arama')" />
                      <i class="bx bx-search-alt search-icon"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-8">
                  <div class="text-sm-end">
                   </div>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>{{ $t("ofirma.Table.Firmaadi") }}</th>
                      <th>{{ $t("ofirma.Table.Telefon") }}</th>

                      <th style="width: 170px; text-align: center;">{{ $t("ofirma.Table.Email") }}</th>
                      <th>{{ $t("ofirma.Table.Vergino") }}</th>

                      <th style="width: 370px; text-align: center;">{{ $t("ofirma.Table.Aciklama") }}</th>
                      <th style="text-align: center;">{{ $t("ofirma.Table.Islem") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="Data in TableData" :key="Data.Id">
                      <th scope="row">{{ Data.Firmaadi }}</th>
                      <td>{{ Data.Telefon }}</td>

                      <td>{{ Data.Email }}</td>
                      <td>{{ Data.Vergino }}</td>

                      <td>{{ Data.Aciklama }}</td>
                      <td style="width: 85px">
                        <b-button-group>
                          <b-button variant="success" v-tooltip="$t('ofirma.Table.Duzenle')" v-b-modal.ofirma @click="(DataUpdate = Data), (AddEdit = 'Edit')">
                            <i class="far fa-edit"></i>
                          </b-button>

                          <b-button variant="danger" v-tooltip="$t('ofirma.Table.Sil')" @click="Delete('ofirma', Data.Id)"><i class="far fa-trash-alt"></i></b-button>
                        </b-button-group>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage" :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table" @input="ChangePage(DefaultPage)"> </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AddEdit :Id="DataUpdate" :AddEdit="AddEdit" @TableUpdate="Get" />
    </Layout>
  </Loader>
</template>
